import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../backend/UseAuth";
import { useSignup } from '../backend/Register'
import { getDoc, collection, doc, getFirestore } from "firebase/firestore";
import { useState } from "react";

export default function Visualization() {

    const db = getFirestore();
    const { user } = useAuthContext()
    const { logout } = useSignup()
    const handleSubmit = (e) => {
        logout()
    }
    const [Alldocs, setAlldocs] = useState([]);
    const [singleDoc, setSingledoc] = useState([]);

    useEffect(() => {

        getDoc(doc(db, "users", user.uid)).then(docSnap => {
            if (docSnap.exists()) {
                setSingledoc(docSnap.data());
            } else {
                console.log("No such document!");
            }
        })
    }, [])

    return (
        <React.Fragment>
            <div className="overlay"></div>


            <div className="main-body-wrapper d-flex">

                <div className="sidebar-wrapper bg--accent">
                    <div className="sidebar-inner">
                        <ul className="sidebar-menu">
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/contributions" className="sidebar-menu-link"><img src="assets/images/icon/menu1.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/tests" className="sidebar-menu-link"><img src="assets/images/icon/menu2.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/domain" className="sidebar-menu-link"> <img src="assets/images/icon/menu3.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/visualization" className="sidebar-menu-link"> <img src="assets/images/icon/menu4.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/lists" className="sidebar-menu-link"> <img src="assets/images/icon/menu5.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/profile" className="sidebar-menu-link"> <img src="assets/images/icon/menu6.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="main-content">
                    <div className="main-content-inner">

                        <div className="top-menu-wrapper bg-white">
                            <div className="top-menu-inner d-flex flex-wrap gap-2 justify-content-between">
                                <div className="d-sm-block">
                                    <div className="sidebar-toggler fs--20px d-md-none"><i className="fas fa-bars"></i></div>
                                </div>
                                <a href="contributions.html" className="logo"><img src="assets/images/logo.png" alt="logo" /></a>
                                <ul className="top-menu d-flex flex-wrap gap-3">
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-bell"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <div className="dropdown-header">
                                                    <div className="d-flex flex-wrap justify-content-between pb-2">
                                                        <h6>Notifications</h6>
                                                        <span>Mark all as read</span>
                                                    </div>
                                                    <ul className="notification">
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li className="notification-item">
                                                            <div className="d-flex gap-3">
                                                                <div className="notification-item__thumb">
                                                                    <i className="fas fa-user"></i>
                                                                </div>
                                                                <div className="notification-item__content">
                                                                    <h6 className="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p className="fs--12px">1 min ago</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="top-menu-item">
                                        <a href="#" className="top-menu-link"><i className="fas fa-user"></i></a>
                                        <div className="dropdown-wrapper">
                                            <div className="dropdown-inner">
                                                <ul className="notification">
                                                    <li className="notification-item border-0">
                                                        <div className="d-flex gap-3">
                                                            <div className="notification-item__thumb">
                                                                <i className="fas fa-user"></i>
                                                            </div>
                                                            <div className="notification-item__content">
                                                                {
                                                                    singleDoc.firstname && <h6 className="notification-item__content-name">
                                                                        {singleDoc.firstname + " " + singleDoc.lastname}
                                                                    </h6>
                                                                }
                                                                <p>Admin</p>
                                                                {
                                                                    <Link to="/profile" className="mt-3 d-block fs--14px fw-semibold">Edit Profile
                                                                    </Link>
                                                                }
                                                                {
                                                                    <Link to="/" onClick={handleSubmit} className="mt-1 d-block fs--14px fw-semibold text--danger">  Log Out
                                                                    </Link>
                                                                }
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="main-content-inner-inner">
                            <div className="card custom--card">
                                <div className="card-header d-flex flex-wrap gap-3 justify-content-between align-items-start">
                                    <div className="card-header__left">
                                        <h4 className="title">Visualization</h4>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-xl-8 col-xxl-9 pe-xxl-5">
                                            <div className="d-flex flex-wrap justify-content-between gap-3 mb-4">
                                                <div className="search-wrapper">
                                                    <form action="">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control form--control ps-5" />
                                                            <button className="btn fs--18px border-0 btn--icon" type="submit"><i className="fas fa-search"></i></button>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="d-flex flex-wrap gap-3">
                                                    <select>
                                                        <option value="">Filter by</option>
                                                        <option value="">Upper to Low</option>
                                                        <option value="">Lower to Upper</option>
                                                    </select>
                                                    <select>
                                                        <option value="">Filter by</option>
                                                        <option value="">Upper to Low</option>
                                                        <option value="">Lower to Upper</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="overview-wrapper d-flex flex-wrap justify-content-between">
                                                <div className="overall-item flex-column style--two">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-user"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <p>Users</p>
                                                        <h4 className="value">500</h4>
                                                        <p>Per Day</p>
                                                    </div>
                                                </div>
                                                <div className="overall-item flex-column style--two">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-eye"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <p>Views</p>
                                                        <h4 className="value">2.5k</h4>
                                                        <p>Per Day</p>
                                                    </div>
                                                </div>
                                                <div className="overall-item flex-column style--two">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-compass"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <p>Visits</p>
                                                        <h4 className="value">3.0</h4>
                                                        <p>Per Day</p>
                                                    </div>
                                                </div>
                                                <div className="overall-item flex-column style--two">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-file-alt"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <p>Contributions</p>
                                                        <h4 className="value">1.0k</h4>
                                                        <p>Per Day</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="overview-wrapper style--two mt-4">
                                                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 mb-sm-4">
                                                    <h4 className="title ps-3">Users</h4>
                                                    <p className="fw-medium mb-0">Past 7 days</p>
                                                </div>
                                                <div id="apex-bar-chart"> </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-xxl-3">
                                            <div className="overall-wrapper">
                                                <h3 className="title text-white mb-4">Overall Statistics</h3>
                                                <div className="overall-item">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-user"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <h4 className="value text-white">500</h4>
                                                        <p className="text-white fs--14px">Users</p>
                                                    </div>
                                                </div>
                                                <div className="overall-item">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-eye"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <h4 className="value text-white">2.5k</h4>
                                                        <p className="text-white fs--14px">Views</p>
                                                    </div>
                                                </div>
                                                <div className="overall-item">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-compass"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <h4 className="value text-white">3.0</h4>
                                                        <p className="text-white fs--14px">Visits</p>
                                                    </div>
                                                </div>
                                                <div className="overall-item">
                                                    <div className="overall-item__icon">
                                                        <i className="fas fa-file-alt"></i>
                                                    </div>
                                                    <div className="overall-item__content">
                                                        <h4 className="value text-white">1.0k</h4>
                                                        <p className="text-white fs--14px">Contributions</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}